module.exports = __webpack_public_path__ + "img/icon_parkingService.0d219809.png";